import components from "./components";
import * as constants from "./companyInfo.constants";

export default {
  components,
  constants
};
